import styled from 'styled-components';
import { NavLink as NavLinkDefault } from 'react-router-dom';
import { Subtitle } from 'components/Typography';

// TODO: TFR-45:NavLink make unique name or do not export
export const NavLink = styled(NavLinkDefault)`
  height: 4rem;
  padding: 0 1.25rem;
  border-radius: 1rem;
  text-decoration: none;
  text-transform: capitalize;
  display: flex;
  justify-content: left;
  align-items: center;
  color: ${({ theme }) => theme.colors.navyGreen};
  span {
    margin-right: 1.25rem;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.iconGray};
    font-size: 1.5rem;
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.navyGreenLight};
  }
  &.selected {
    font-weight: 600;
    opacity: 100%;
    background-color: ${({ theme }) => theme.colors.navyGreenLight};
    span {
      color: ${({ theme }) => theme.colors.greenDark};
    }
  }
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const LinkLabel = styled(Subtitle)``;

// TODO: TFR-45 make unique name or do not export
export const IconContainer = styled.span`
  width: 1.5rem;
  height: 1.5rem;
`;
